import { useSelector } from 'react-redux';
import { noOfDaysInPicker } from '../../common/constants';
import React, { useEffect, useMemo, useState } from 'react';
import './styles.scss';
import moment from 'moment';
import { TimeOption } from '../../common/features/restaurant/restaurantModels';
import { convertTo24Hour } from '../../common/utils';
import { getAsapTime, getCurrentTimeASAP } from '../../common/utils/date-time-helper-utils';
import CustomSelect from '../../components/CustomSelect';
import { useDispatch } from 'react-redux';
import { isScheduleOrderPlaceOrder } from '../../common/features/cart/cartActions';

const options: any = { weekday: 'short', day: '2-digit', month: 'short' };

const PickDateSelectionDesktop = ({
  onClose,
  selectDate,
  handleDateChange,
  handleApply,
  asapFlow,
}: any) => {
  const eventOrderSlot = useSelector((state: any) => state.restaurant.eventOrderSlot);
  const [selectedTime, setSelectedTime] = useState<TimeOption | null>(null);
  const [isAsapSelected, setIsAsapSelected] = useState(false);
  const isEventDate = useSelector((state: any) => state.cart.isEventDate);
  const eventDate = useSelector((state: any) => state.cart.eventDate);
  const selectedDate = useSelector((state: any) => state.cart.selectedDate);
  const selectedTimeSlotRedux = useSelector((state: any) => state.cart?.selectedTimeSlot);
  const [slectedTimeSlot, setSelectedTimeSlot] = useState(selectedTimeSlotRedux || '');
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile);

  const dispatch = useDispatch();
  // Restaurant details for ASAP calculation
  const restaurantDetail = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const restaurantDefaultDeliveryEta = useSelector(
    (state: any) => restaurantDetail?.defaultDeliveryETA
  );
  const restaurantDefaultPickupEta = restaurantDetail?.defaultPickUpETA;
  const isSchedularOrdervalue = useSelector((state: any) => state.cart?.isScheduleOrder);

  const slugFromLocalStorage =
    localStorage.getItem('restaurant') && JSON.parse(localStorage.getItem('restaurant') || '');
  const isDeliveryOrderType = restaurantDetail?.orderTypes?.some((type: any) => {
    return type?.typeName === slugFromLocalStorage?.menuType && type?.typeGroup === 'S';
  });

  const isRestaurantClosed = useSelector((state: any) => state.scheduler.restaurantClosed);
  const nextSesstionStartTime = restaurantDetail?.nextSession?.nextSessionStartTime;

  // Memoized ASAP time calculation
  const asapTime = useMemo(() => {
    return getAsapTime(
      isDeliveryOrderType,
      restaurantDefaultDeliveryEta || 0,
      restaurantDefaultPickupEta || 0,
      restaurantDetail?.timeZoneCd || '',
      isRestaurantClosed,
      nextSesstionStartTime
    );
  }, [
    isDeliveryOrderType,
    restaurantDefaultDeliveryEta,
    restaurantDefaultPickupEta,
    restaurantDetail?.timeZoneCd,
    isRestaurantClosed,
    nextSesstionStartTime,
  ]);

  // Memoized ASAP time calculation
  const asapTimeNew = useMemo(() => {
    return getCurrentTimeASAP(
      isDeliveryOrderType,
      restaurantDefaultDeliveryEta || 0,
      restaurantDefaultPickupEta || 0,
      restaurantDetail?.timeZoneCd || '',
      isRestaurantClosed,
      nextSesstionStartTime
    );
  }, [
    isDeliveryOrderType,
    restaurantDefaultDeliveryEta,
    restaurantDefaultPickupEta,
    restaurantDetail?.timeZoneCd,
    isRestaurantClosed,
    nextSesstionStartTime,
  ]);

  // const isBlocked = useMemo(() => {
  //     const now = new Date(asapTime);
  //     const currentTime = now.toTimeString().split(" ")[0]; // "HH:MM:SS"
  //     const currentWeekday = now.toLocaleDateString("en-US", { weekday: "long" });

  //     const workingHours = restaurantDetail?.onlineWorkingHours?.filter(
  //         (wh: any) => wh.weekday === currentWeekday && wh.isEnabled === "1"
  //     );

  //     if (!workingHours || workingHours.length === 0) {
  //         return true; // No working hours => blocked
  //     }

  //     // Function to check if time is in range
  //     const isInRange = (start: string, end: string, time: string) => {
  //         const parse = (t: string) => {
  //             const [h, m, s] = t.split(":").map(Number);
  //             return h * 3600 + m * 60 + s;
  //         };

  //         const t = parse(time);
  //         const s = parse(start);
  //         const e = parse(end);

  //         // Handles overnight times (e.g., 23:00 - 02:00 next day)
  //         if (s <= e) {
  //             return t >= s && t <= e;
  //         } else {
  //             return t >= s || t <= e;
  //         }
  //     };

  //     const allowed = workingHours.some((wh: any) =>
  //         isInRange(wh.openingTime, wh.closingTime, currentTime)
  //     );
  //     return !allowed; // If not allowed => blocked

  // }, [restaurantDetail?.workingHours, asapTime])

  useEffect(() => {
    if (selectedDate) {
     // handleDateChange(selectedDate);
    }
    if (isEventDate && eventOrderSlot?.length < 1) {
      let timeSlots = eventOrderSlot?.filter(
        (slot: any) =>
          new Date(slot?.startDate)?.toISOString()?.split('T')[0] ===
            new Date(selectedDate || eventOrderSlot?.[0]?.startDate)
              ?.toISOString()
              ?.split('T')[0] && slot?.eventSlug === eventDate
      )?.[0]?.timeSlots;
      let timeSlot = timeSlots?.[0];
      let date;
      if (!timeSlot) {
        timeSlot = eventOrderSlot?.filter((slot: any) => slot?.eventSlug === eventDate)?.[0]
          ?.timeSlots?.[0];
        date = new Date(eventOrderSlot?.[0]?.startDate);
      } else {
        date = new Date(selectedDate || eventOrderSlot?.[0]?.startDate);
      }

      if (!selectedTimeSlotRedux && selectedTimeSlotRedux === '') {
        const timeDate = new Date(
          date.setHours(
            parseInt(timeSlot?.startTime?.split(':')[0]),
            parseInt(timeSlot?.startTime.split(':')[1])
          )
        );
        handleDateChange(timeDate);
        setSelectedTime(timeSlot);
        setSelectedTimeSlot(
          moment(timeSlot?.startTime, 'HH:mm:ss').format('hh:mm A') +
            ' - ' +
            moment(timeSlot?.endTime, 'HH:mm:ss').format('hh:mm A')
        );
      } else {
        const startTime = convertTo24Hour(selectedTimeSlotRedux.split(' - ')[0]?.trim());
        let timeSlot = timeSlots?.filter((timeSlot: any) => timeSlot?.startTime === startTime)?.[0];
        if (!timeSlot?.startTime) {
          return;
        }
        let [hours, minutes] = timeSlot?.startTime?.split(':')?.map(Number);
        const timeDate = new Date(date); // Copy date to avoid mutating original
        timeDate.setHours(hours, minutes, 0, 0);
        handleDateChange(timeDate);
        setSelectedTime(timeSlot);
      }
    }
  }, []);

  const datesList = useMemo(() => {
    if (isEventDate) {
      const dates: any = [];
      eventOrderSlot
        ?.filter((slot: any) => slot?.eventSlug === eventDate)
        ?.map((slot: any, index: number) => {
          const date = moment(slot?.startDate).tz(restaurantDetail?.timeZoneCd).toDate();
          const formattedDate = date.toLocaleDateString('en-US', options).split(' ');
          // if (index < noOfDaysInPicker){
          dates.push({
            day: formattedDate[0].replace(',', '').toUpperCase(),
            date: formattedDate[1],
            month: formattedDate[2].toUpperCase(),
            fullDate: date, // Store the full date object for comparison
          });

          // }
        });
      handleDateChange(dates[0]?.fullDate);
      return dates;
    } else {
      return [];
    }
  }, [eventOrderSlot]);

  const [isSchedularOrder, setIsScdularOrder] = useState(isSchedularOrdervalue);
  const handleDateChangeHandler = (date: Date) => {
    if (isEventDate) {
      const eventSlot = eventOrderSlot?.filter(
        (slot: any) =>
          new Date(slot.startDate)?.toISOString().split('T')[0] ===
            new Date(date || eventOrderSlot[0].startDate).toISOString().split('T')[0] &&
          slot.eventSlug === eventDate
      )?.[0]?.timeSlots?.[0];
      if (eventSlot) {
        const timeDate = new Date(
          date.setHours(
            parseInt(eventSlot.startTime.split(':')[0]),
            parseInt(eventSlot.startTime.split(':')[1])
          )
        );
        handleDateChange(timeDate);
        setSelectedTime(eventSlot);
      }
    } else {
      handleDateChange(date);
    }
  };

  const handleTimeSelect = (value: string) => {
    if (value === '') {
      setIsScdularOrder(false);
      // ASAP selected, use opening time with service window      
      if (asapTimeNew && restaurantDetail?.timeZoneCd) {
        handleDateChange(new Date(asapTimeNew.restaurantDateTime));
        setIsAsapSelected(true);
        // Don't update Redux state immediately - wait for user to click Continue
      }
      return;
    }
    else
    {
      setIsScdularOrder(true);
    }
 
    const [datePart, timePart] = value.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    let [hours, minutes] = timePart.split(":").map(Number);
    const dateObj = new Date(year, month - 1, day, hours, minutes);
 
    selectDate.setDate(day);
    selectDate.setMonth(month-1);
    selectDate.setFullYear(year);
 
    // let [hours, minutes] = value?.split(':')?.map(Number);
    const now = new Date(asapTimeNew?.restaurantDateTime);
 
    if (isNaN(hours)) {
      hours = now?.getHours();
      minutes = now?.getMinutes();
    }
    const newDate = new Date(selectDate || now);
    newDate.setHours(hours);
    newDate.setMinutes(minutes);
    handleDateChange(newDate);
    setIsAsapSelected(false);
    // Don't update Redux state immediately - wait for user to click Continue
  };

  //   const [datePart, timePart] = value.split(" ");
  //   const [year, month, day] = datePart.split("-").map(Number);
  //   let [hours, minutes] = timePart.split(":").map(Number);
  //   const dateObj = new Date(year, month - 1, day, hours, minutes);

  //   selectDate.setDate(day);
  //   selectDate.setMonth(month-1);
  //   selectDate.setFullYear(year);

  //   // let [hours, minutes] = value?.split(':')?.map(Number);
  //   const now = new Date(asapTimeNew?.restaurantDateTime);

  //   if (isNaN(hours)) {
  //     hours = now?.getHours();
  //     minutes = now?.getMinutes();
  //   }
  //   const newDate = new Date(selectDate || now);
  //   newDate.setHours(hours);
  //   newDate.setMinutes(minutes);
  //   handleDateChange(newDate);
  //   setIsAsapSelected(false);
  //   // Don't update Redux state immediately - wait for user to click Continue
  // };

 const optionsList = () => {
       let options: any[] = [];
   
       if (asapFlow && restaurantDetail?.timeZoneCd) {
         options.push({ value: '', label: 'ASAP' });
       }
   
       // Get current time in restaurant's timezone (e.g., America/Chicago)
       const restaurantTime = restaurantDetail?.timeZoneCd
         ? moment().tz(restaurantDetail.timeZoneCd)
         : moment();
       const eta = isDeliveryOrderType
         ? restaurantDefaultDeliveryEta || 0
         : restaurantDefaultPickupEta || 0;
       const restaurantTimeWithEta = restaurantTime.clone().add(eta, 'minutes');
       const asapMomentTime = moment(asapTime)?.tz(restaurantDetail?.timeZoneCd)
       
       const nowTime = isRestaurantClosed
         ? asapMomentTime.hours() * 60 + asapMomentTime.minutes()
         : restaurantTimeWithEta.hours() * 60 + restaurantTimeWithEta.minutes();
       const currentWeekday = restaurantTimeWithEta.format('dddd'); // e.g., "Monday"
      
   
       const workingHours = isDeliveryOrderType
         ? restaurantDetail?.onlineWorkingHours?.filter(
             (wh: any) => wh.weekday === currentWeekday && wh.isEnabled === '1'
           )
         : restaurantDetail?.workingHoursWithPickUpCutoffTime?.filter(
             (wh: any) => wh.weekday === currentWeekday && wh.isEnabled === '1'
           );
   
       // Parser helper
       const parseToMinutes = (t: string) => {
         const [h, m, s] = t.split(':').map(Number);
         return h * 60 + m; // seconds not needed for slots
       };
       const getBufferSession = (workingHours: any, nowMinutes: any) => {
         let currentIndex = -1;
   
         // 1. Find current active session
         workingHours?.forEach((wh: any, i: number) => {
           const s = parseToMinutes(wh.openingTime);
           const e = parseToMinutes(wh.closingTime);
   
           const isInCurrent =
             s <= e ? nowMinutes >= s+eta+60 && nowMinutes <= e : nowMinutes >= s || nowMinutes <= e; // overnight
   
           if (isInCurrent) currentIndex = i;
         });
   
         // If we found a current session → return it
         if (currentIndex !== -1) return currentIndex;
   
         // 2. Current session not found → find next future session
         for (let i = 0; i < workingHours.length; i++) {
           const s = parseToMinutes(workingHours[i].openingTime);
           if (s > nowMinutes) return i;
         }
   
         // 3. No future session (all completed) → no buffer
         return -1;
       };
       const isSessionStartSlot = (openingTime: string, optionMinutes: number) => {
     const open = parseToMinutes(openingTime);
   
     // round opening time to nearest 15-min slot
     const nearestSlot = Math.ceil(open/ 15) * 15;
     return optionMinutes === nearestSlot;
   };
   
       const isInRange = (
         start: string,
         end: string,
         optionMinutes: number,
         eta: number,
         nowMinutes: number,
         bufferIndex: any,
         index: number,
         restaurantOpeningTime:any
       ) => {
         const s = parseToMinutes(start);
         const e = parseToMinutes(end);
         const isInSession =
     s <= e
       ? optionMinutes >= s && optionMinutes <= e
       : optionMinutes >= s || optionMinutes <= e;
         const applyBuffer =
     index === bufferIndex &&  nowMinutes >= s && nowMinutes <= e;;
   //    &&
   //   isSessionStartSlot(start, optionMinutes);
   // console.log({bufferIndex});
   const buffer = applyBuffer ? 60 : 0;
         // Normal case
         if (s <= e) {
           return optionMinutes >= s + eta + buffer && optionMinutes <= e;
         }
         // Overnight case (e.g., 23:00 → 02:00)
         else {
           return optionMinutes >= s || optionMinutes <= e;
         }
       };
   
       const systemTimeZone = moment.tz.guess(); // detect system timezone dynamically
       const bufferIndex = getBufferSession(workingHours, nowTime+60);
       for (let hour = 0; hour < 24; hour++) {
         for (let minute = 0; minute < 60; minute += 15) {
           const optionTime = hour * 60 + minute;
   
           if (optionTime >= nowTime+60) {
             const allowed = workingHours?.some((wh: any, index: number) => {
               const restaurantOpeningTime = workingHours?.[index]?.openingTime || '';
   
               return isInRange(
                 wh.openingTime,
                 wh.closingTime,
                 optionTime,
                 eta,
                 nowTime,
                 bufferIndex,
                 index,
                 restaurantOpeningTime
               );
             });
   
             if (allowed) {
               const restaurantSlot = moment(restaurantTimeWithEta)
                 .startOf('day')
                 .add(hour, 'hours')
                 .add(minute, 'minutes');
   
               // Label in restaurant's timezone (12h format, e.g., 01:45 PM Chicago time)
               const displayTime = restaurantSlot
                 .clone()
                 .tz(restaurantDetail?.timeZone)
                 .format('hh:mm A');
   
               // Value in system timezone (24h format, e.g., 13:45 local system time)
               const systemSlot = restaurantSlot.clone().tz(restaurantDetail?.timeZone).format('YYYY-MM-DD HH:mm');
               const value = systemSlot;
   
               options.push({ value, label: displayTime });
             }
           }
         }
       }
       return options;
     };

  const optionsArray = useMemo(optionsList, [asapFlow, restaurantDetail?.timeZoneCd]);

  return (
    <>
      <div className="date-time-selection-container-Desktop">
        <p className="subheading-pickup-time-desktop">
          Please confirm the pickup time {restaurantDetail?.timeZone}, then click 'Save' to
          continue.
        </p>

        <div className="date-time-selction-container">
          <div className="selectDate-container-New-desktop">
            <h2>Select a Date</h2>

            <div className="date-items-container-New-desktop">
              {(() => {
                // Generate the next 5 dates starting from today
                let dates = [];
                const today = new Date();

                if (!isEventDate) {
                  let newDate = moment().tz(restaurantDetail?.timeZoneCd);                  
                 //  const newDate = moment(today);
                  dates.push({
                    day: newDate.format('ddd').toUpperCase(),
                    date: newDate.format('DD'),
                    month: newDate.format('MMM').toUpperCase(),
                    fullDate: newDate.toDate(), // native Date object
                  });
                  
                  // for (let i = 0; i < noOfDaysInPicker; i++) {
                  //   const date = moment.tz(restaurantDetail?.timeZone).add(i, 'days');


                  //   const utcISO = moment(date).utc().toISOString();
                  //   console.log({ date, utcISO });

                  //   dates.push({
                  //     day: date.format('ddd').toUpperCase(),
                  //     date: date.format('DD'),
                  //     month: date.format('MMM').toUpperCase(),
                  //     fullDate: date.toDate(), // native Date object
                  //   });
                  //   // const date = new Date(today);
                  //   // date.setDate(today.getDate() + i);
                  //   // const formattedDate = date.toLocaleDateString('en-US', options).split(' ');
                  //   // dates.push({
                  //   //   day: formattedDate[0].replace(',', '').toUpperCase(),
                  //   //   date: formattedDate[1],
                  //   //   month: formattedDate[2].toUpperCase(),
                  //   //   fullDate: date, // Store the full date object for comparison
                  //   // });
                  // }
                } else {
                  dates = datesList;
                }

                return dates.map((date: any, index: number) => {
                  const dateKey = `${date.day}-${date.date}-${date.month}`;

                  // Create a date-only version of date.fullDate (zero out time)
                  const fullDateOnly = new Date(date.fullDate);
                  // Set hours and minutes from selectDate to fullDateOnly
                  if (selectDate) {
                    const selectDateObj = new Date(selectDate);
                    fullDateOnly.setHours(
                      0,
                      0,
                      0,
                      0
                      // selectDateObj.getHours(),
                      // selectDateObj.getMinutes(),
                      // selectDateObj.getSeconds(),
                      // selectDateObj.getMilliseconds()
                    );
                  }
                  // Create a date-only version of today
                  const todayOnly = new Date();
                  todayOnly.setHours(0, 0, 0, 0);

                  // isPastDate: true if fullDateOnly is before todayOnly
                  const isPastDate = fullDateOnly < todayOnly;

                  // isSelected: true if fullDateOnly matches selectDate's date (ignore time)
                  const isSelectedEventDate =
                    selectDate &&
                    date.fullDate.getDate() === selectDate.getDate() &&
                    date.fullDate.getMonth() === selectDate.getMonth();

                  const isSelected = selectDate && parseInt(date.date) === selectDate.getDate() &&
                    date.fullDate.getMonth() === selectDate.getMonth();

                  return (
                    <div
                      className={`date-item-New-desktop ${isSelectedEventDate && isEventDate ? 'selected' : isSelected ? 'selected' : ''} ${
                        isPastDate ? 'disabled' : ''
                      }`}
                      onClick={() => {
                        if (!isPastDate) {
                          if (isEventDate) {
                            const newDate = new Date(selectDate);
                            newDate.setFullYear(date.fullDate.getFullYear());
                            newDate.setMonth(date.fullDate.getMonth());
                            newDate.setDate(date.fullDate.getDate());
                            handleDateChangeHandler(newDate);
                            setSelectedTimeSlot('');
                            setSelectedTime(null);
                          }
                        }
                      }}
                      key={dateKey}
                    >
                      <p>{date.day}</p>
                      <p>{date.month}</p>
                      <p>{date.date}</p>
                    </div>
                  );
                });
              })()}
            </div>
          </div>

          <div className="time-selection-New-desktop">
            <h2>Select a {isEventDate ? 'Slot' : 'Time'}</h2>

            <div className="time-picker-container-New-desktop">
              {isEventDate ? (
                <div className="scrollable-divEDP ">
                  <div className="time-options2">
                    {Array.isArray(eventOrderSlot) &&
                      eventOrderSlot
                        .filter((slot: any) => {
                          return (
                            moment(slot?.startDate).format('MM/DD/YYYY') ===
                              moment(selectDate).format('MM/DD/YYYY') &&
                            slot.eventSlug === eventDate
                          );
                        })?.[0]
                        ?.timeSlots?.map((time: TimeOption, index: number) => (
                          <div
                            key={index}
                            className={`time-option ${
                              time.currentOrderPerSlot === time.orderPerSlot ? 'disabled' : ''
                            } ${selectedTime?.startTime === time?.startTime ? 'active' : ''}`}
                            onClick={() => {
                              const date = new Date(selectDate);
                              const timeDate = new Date(
                                date.setHours(
                                  parseInt(time?.startTime.split(':')[0]),
                                  parseInt(time?.startTime.split(':')[1])
                                )
                              );
                              handleDateChange(timeDate);
                              setSelectedTime(time);
                              setSelectedTimeSlot(
                                moment(time?.startTime, 'HH:mm:ss').format('hh:mm A') +
                                  ' - ' +
                                  moment(time?.endTime, 'HH:mm:ss').format('hh:mm A')
                              );
                            }}
                          >
                            {moment(time?.startTime, 'HH:mm:ss').format('hh:mm A')} -{' '}
                            {moment(time?.endTime, 'HH:mm:ss').format('hh:mm A')}
                          </div>
                        ))}
                  </div>
                </div>
              ) : (
                <>
                  <CustomSelect
                    options={optionsArray || []}
                    value={
                      isAsapSelected
                        ? ''
                          : selectDate 
                          ? `${selectDate?.getFullYear()?.toString().padStart(2, '0')}-${String(selectDate.getMonth() + 1)?.padStart(2, '0')}-${selectDate?.getDate()?.toString().padStart(2, '0')} ${selectDate?.getHours()?.toString().padStart(2, '0')}:${selectDate
                            ?.getMinutes()
                            ?.toString()
                            .padStart(2, '0')}`
                        : ''
                    }
                    onChange={handleTimeSelect}
                    placeholder="ASAP"
                  />
                </>
              )}
            </div>
          </div>
        </div>

        <div className="action-buttons-desktopview">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className={`apply-btn ${
              selectDate && (isEventDate ? !(!selectedTime || !slectedTimeSlot) : true)
                ? 'active'
                : 'disabled'
            }`}
            onClick={() => {
              // handleApply will update Redux state when user clicks Continue
              dispatch(isScheduleOrderPlaceOrder(isSchedularOrder));
              handleApply(selectDate, slectedTimeSlot);
            }}
            disabled={!selectDate || (isEventDate && (!selectedTime || !slectedTimeSlot))}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default PickDateSelectionDesktop;
